import script from "./MarvinButton.vue?vue&type=script&setup=true&lang=js"
export * from "./MarvinButton.vue?vue&type=script&setup=true&lang=js"

import "./MarvinButton.vue?vue&type=style&index=0&id=1277525b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1277525b"]])

export default __exports__